<template>
    <Main>
        <div class="alert alert-warning dark" role="alert" v-if="!userInfo['has_setting']">
            <h5>
                <i class="icon fas fa-exclamation-triangle"></i>
                {{ $t('textCommon.titleWarning') }}
            </h5>
            {{ $t('connect.alertSetting1') }}
            <a class="alert-link text-underline" href="javascript:void(0)" @click="$router.push({ name: 'settingKintone' })" data-bs-original-title="" title="">
                {{ $t('connect.alertSettingAccountLink') }}
            </a>
        </div>
        <div class="row box-step">
            <div class="u-pearl col-3" :class="{ done: stepActive > 0, current: stepActive === 0 }">
                <span class="u-pearl-number">1</span>
                <span class="u-pearl-title">
                    {{ $t('connect.step1Title') }}
                </span>
            </div>
            <div class="u-pearl col-3" :class="{ done: stepActive > 1, current: stepActive === 1 }">
                <span class="u-pearl-number">2</span>
                <span class="u-pearl-title">
                    {{ $t('connect.step2Title') }}
                </span>
            </div>
            <div class="u-pearl col-3" :class="{ done: stepActive > 2, current: stepActive === 2 }">
                <span class="u-pearl-number">3</span>
                <span class="u-pearl-title">
                    {{ $t('connect.step3Title') }}
                </span>
            </div>
            <div class="u-pearl col-3" :class="{ done: stepActive > 3, current: stepActive === 3 }">
                <span class="u-pearl-number">4</span>
                <span class="u-pearl-title">
                    {{ $t('connect.step4Title') }}
                </span>
            </div>
        </div>
        <div class="box-step__content" v-if="userInfo['has_setting'] && !isLoading">
            <step-1 v-if="stepActive === 0" :data.sync="data" @nextStep="next"> </step-1>
            <step-2 v-if="stepActive === 1" :data.sync="data" @nextStep="next" @prevStep="prev"> </step-2>
            <step-3 v-if="stepActive === 2" :data.sync="data" @nextStep="next" @prevStep="prev"> </step-3>
            <step-4 v-if="stepActive === 3" :data.sync="data" @nextStep="next" @prevStep="prev"></step-4>
        </div>

        <box-loading v-if="isLoading"></box-loading>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import { mapState } from 'vuex';
import Step1 from '@/views/share/steps/step1';
import Step2 from '@/views/share/steps/step2';
import Step3 from '@/views/share/steps/step3/index.vue';
import Step4 from '@/views/share/steps/step4';
import BoxLoading from '@/components/partials/BoxLoading';
export default {
    name: 'AddShare',
    components: {
        BoxLoading,
        Step1,
        Step2,
        Step3,
        Step4,
        Main
    },
    data() {
        return {
            stepActive: 0,
            isLoading: false,
            data: {
                // step 1
                workspace_id: '',
                workspace_type: '',
                workspace_uid: '',
                id_banner: null,
                url_banner: null,
                link_banner: null,
                // step 2
                app_id: '',
                app_name: '',
                // step 3
                view_id: null,
                view_name: '',
                arrayContentFilter: [],
                information_view: {},
                code_kintone: [],
                dataFilter: '',
                typeFilter: 'and',
                arrayFieldView: null,
                arrayFieldDisabled: null,
                fieldDisplayLayout: null,
                // step 4
                shareName: '',
                typeShare: 'form-multi-filter',
                condition_setting : 'and',
                // type filter
                member_id: '',
                listMemberShare: [{ member_id: [], roles: ['detail'] }],
                // type multi filter
                filterContents: [],
                rolesMultiFilter: [1]
            }
        };
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    watch: {
        data: {
            deep: true,
            handler: function () {
                localStorage.setItem('dataListConnect', JSON.stringify(this.data));
            }
        }
    },
    mounted() {
        this.stepActive = localStorage.getItem('localSetStep') ? parseInt(localStorage.getItem('localSetStep')) : 0;
        let queryId = this.$route.query.id;
        let typeShare = this.$route.query.typeShare;
        if (queryId) {
            this.stepActive = localStorage.getItem('localSetStep') ? parseInt(localStorage.getItem('localSetStep')) : 2;
            if (typeShare === 'form-filter') {
                this.handleGetDetailRecord(queryId);
            } else if (typeShare === 'form-multi-filter') {
                this.handleGetDetailMultiRecord(queryId);
            }
        } else {
            let retrievedData = localStorage.getItem('dataListConnect');
            let dataObject = JSON.parse(retrievedData);
            if (dataObject && dataObject['workspace_uid'] !== undefined) {
                this.data = JSON.parse(retrievedData);
            }
        }
    },
    methods: {
        handleGetDetailRecord(idRecord) {
            this.isLoading = true;
            let successCallback = (response) => {
                let { data } = response.data.data;
                if (data) {
                    this.data = Object.assign({}, data);
                    this.data.typeShare = 'form-filter';
                    this.data.app_name = data.app_name;
                    this.data.shareName = data.link_name;
                    this.data.dataFilter = data.data_filter;
                    this.data.arrayFieldView = data.array_field_view || null;
                    this.data.arrayFieldDisabled = data.array_field_disabled || null;
                    this.data.fieldDisplayLayout = data.array_field_detail_hidden || null;
                    this.data.view_id = data.view_id ? data.view_id.toString() : null;
                    this.data.arrayContentFilter = data.array_filter || null;
                    this.data.id_banner = data.banner ? data.banner.id : null;
                    this.data.url_banner = data.banner ? data.banner.path : null;
                    this.data.link_banner = data.link_banner || null;
                    this.data.condition_setting = data.condition_setting || null;
                    let stringFilter = data.data_filter || '';
                    if (stringFilter && stringFilter.length > 0) {
                        this.data.typeFilter = stringFilter.includes(' or ') ? 'or' : 'and';
                    } else {
                        this.data.typeFilter = 'and';
                    }
                    let objMember = {
                        member_id: +data.user_id_share,
                        roles: data['list_role']
                            ? data['list_role']
                                  .filter((elm) => {
                                      if (elm) {
                                          return elm.enable;
                                      } else {
                                          return false;
                                      }
                                  })
                                  .map((elm) => {
                                      return elm.type;
                                  })
                            : []
                    };
                    this.data.listMemberShare = [objMember];
                    localStorage.setItem('dataListConnectViewStep3', data.app_id);
                    this.isLoading = false;
                }
            };
            let errorCallback = () => {
                this.isLoading = false;
            };

            let payload = {
                successCallback,
                errorCallback,
                id: idRecord
            };
            this.$store.dispatch('connect/getDetailConnect', payload);
        },

        handleGetDetailMultiRecord(idRecord) {
            this.isLoading = true;
            let successCallback = (response) => {
                let { data } = response.data.data;
                this.data = Object.assign({}, data);
                this.data.typeShare = 'form-multi-filter';
                this.data.app_name = data.app_name;
                this.data.shareName = data['link_name'];
                this.data.dataFilter = data['data_filter'];
                this.data.arrayFieldView = data['array_field_view'] || null;
                this.data.arrayFieldDisabled = data['array_field_disabled'] || null;
                this.data.fieldDisplayLayout = data['array_field_detail_hidden'] || null;
                this.data['view_id'] = data['view_id'] ? data['view_id'].toString() : null;
                this.data.arrayContentFilter = data['array_filter'] || null;
                this.data.id_banner = data.banner ? data.banner.id : null;
                this.data.url_banner = data.banner ? data.banner.path : null;
                this.data.link_banner = data.link_banner || null;
                this.data.condition_setting = data.condition_setting || null;
                let stringFilter = data['data_filter'] || '';
                if (stringFilter && stringFilter.length > 0) {
                    this.data.typeFilter = stringFilter.includes(' or ') ? 'or' : 'and';
                } else {
                    this.data.typeFilter = 'and';
                }
                this.data.filterContents = [];
                data.setting.forEach((item) => {
                    this.data.filterContents.push({
                        ...item,
                        error_field: '',
                        error_condition_type: '',
                        error_user_field: ''
                    });
                });
                this.data.rolesMultiFilter = data.role_id;
                localStorage.setItem('dataListConnectViewStep3', data.app_id);
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };

            let payload = {
                successCallback,
                errorCallback,
                id: idRecord
            };
            this.$store.dispatch('dataLinkMulti/detail', payload);
        },

        next() {
            if (this.stepActive++ > 2) this.active = 0;
            localStorage.setItem('localSetStep', this.stepActive);
        },

        prev() {
            if (this.stepActive-- < 0) this.active = 0;
            localStorage.setItem('localSetStep', this.stepActive);
        }
    },
    destroyed() {
        localStorage.removeItem('localSetStep');
        localStorage.removeItem('layoutPage2');
        localStorage.removeItem('layoutPage1');
        localStorage.removeItem('layoutPage3');
        localStorage.removeItem('layoutStep1');
        localStorage.removeItem('layoutStep2');
        localStorage.removeItem('layoutStep3');
        localStorage.removeItem('dataListConnect');
        localStorage.removeItem('dataListConnectViewStep3');
        localStorage.removeItem('arrayContentFilter');
        localStorage.removeItem('listFiltersStep4');
    }
};
</script>
